import { cva, type VariantProps } from "class-variance-authority";
import { type HTMLAttributes } from "react";
import { cn } from "@/lib/utils/cn";

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium leading-none transition-colors",
  {
    variants: {
      variant: {
        default: "bg-primary/10 text-primary",
        secondary: "bg-secondary text-secondary-foreground",
        outline: "border border-border text-foreground",
        draft: "bg-[var(--bg-muted)] text-[var(--muted-foreground)]",
        active: "bg-[var(--ok-subtle)] text-[var(--ok)]",
        paused: "bg-[var(--warn-subtle)] text-[var(--warn)]",
        error: "bg-[var(--danger-subtle)] text-[var(--danger)]",
        pending: "bg-blue-500/10 text-blue-400",
        running: "bg-indigo-500/10 text-indigo-400",
        succeeded: "bg-emerald-500/10 text-emerald-400",
        failed: "bg-rose-500/10 text-rose-400",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
